module.exports = __webpack_public_path__ + "static/assets/a1e41e4d743c03b27eddcd19d1649d81.svg";